export const DescriptionTruncateCount = 140;
